import React from 'react';
import './HeroUnit.css';
import copper from '../img/copper.jpg';

function HeroUnit(props) {
  return (
    <div className="c-herounit">
      <svg className="c-herounit__arrow-icon" width="50" height="20" viewBox="0 0 50 20" xmlns="http://www.w3.org/2000/svg">
          <polygon
            points="25,19.7 45,9 45,0.8 25,11 5.2,0.8 5.2,9 "
            viewBox="0 0 50 20"
            className="c-herounit__arrow-svg"
            fill="#000000"
            strokeWidth="6"
            strokeLinejoin="round"
          />
       </svg>
      <div className="c-herounit__centered-text">
        <svg className="c-herounit__logo u-hideDesktop" version="1.1" x="0px" y="0px" width="200px" height="200px" viewBox="0 0 216 216">
          <path className="c-herounit__logo-path" d="M0,0v216.005h149.642l5.91-29.794l6.974,18.999h1.882l7.086-18.999l5.826,29.794H216V0H0z M8.084,164.31l53.076,43.613
            H8.084V164.31z M207.916,207.923h-26.214l-7.89-37.49h-2.774l-7.527,23.037l-7.398-23.037h-3.221l-7.633,37.49H61.21
            L42.789,138.55l-0.42-1.575L8.084,126.028v-13.52l30.383,9.826l-0.134-0.52l-8.499-31.95l-21.75-6.947V69.385l17.835,5.767
            L8.096,8.082h199.82V207.923z"/>
          <path className="c-herounit__logo-path" d="M133.263,205.21c4.775,0,8.402-1.318,10.876-3.944l-2.824-4.901c-1.82,2.299-4.341,3.454-7.563,3.454
            c-2.814,0-5.067-1.074-6.757-3.221c-1.688-2.147-2.532-5.054-2.532-8.706c0-3.659,0.91-6.682,2.73-9.068
            c1.821-2.392,4.155-3.582,7.003-3.582c3.002,0,5.181,0.677,6.535,2.03l2.497-5.018c-2.349-1.605-5.485-2.404-9.406-2.404
            c-4.574,0-8.329,1.698-11.262,5.1c-2.932,3.396-4.399,7.626-4.399,12.686c0,5.427,1.321,9.715,3.968,12.86
            C124.775,203.634,128.486,205.21,133.263,205.21z"/>
          <path className="c-herounit__logo-path" d="M192.336,199.818c-2.319,0-4.677-0.841-7.072-2.521l-2.24,5.438c2.567,1.646,5.447,2.475,8.636,2.475
            c3.673,0,6.603-0.898,8.788-2.685c2.185-1.791,3.279-4.072,3.279-6.839c0-1.54-0.266-2.94-0.794-4.189
            c-0.528-1.254-1.298-2.352-2.311-3.291c-1.013-0.945-2.661-1.972-4.948-3.092c-4.341-2.118-6.512-4.155-6.512-6.115
            c0-1.185,0.385-2.147,1.155-2.883c0.771-0.741,1.855-1.108,3.256-1.108c2.366,0,4.612,0.759,6.745,2.287l1.844-5.229
            c-1.853-1.481-4.752-2.217-8.705-2.217c-3.035,0-5.521,0.869-7.458,2.614c-1.937,1.738-2.905,3.933-2.905,6.582
            c0,1.412,0.245,2.707,0.735,3.874s1.19,2.171,2.101,3.022c0.91,0.846,2.675,1.926,5.298,3.244c2.623,1.313,4.353,2.498,5.193,3.56
            c0.84,1.056,1.261,2.171,1.261,3.338C197.682,198.569,195.898,199.818,192.336,199.818z"/>
        </svg>
        <svg className="c-herounit__logo u-hideMobile" version="1.1" x="0px" y="0px" width="200px" height="200px" viewBox="0 0 216 216">
          <defs>
            <clipPath id="myClip">
              <path className="c-herounit__logo-path" d="M0,0v216.005h149.642l5.91-29.794l6.974,18.999h1.882l7.086-18.999l5.826,29.794H216V0H0z M8.084,164.31l53.076,43.613
                H8.084V164.31z M207.916,207.923h-26.214l-7.89-37.49h-2.774l-7.527,23.037l-7.398-23.037h-3.221l-7.633,37.49H61.21
                L42.789,138.55l-0.42-1.575L8.084,126.028v-13.52l30.383,9.826l-0.134-0.52l-8.499-31.95l-21.75-6.947V69.385l17.835,5.767
                L8.096,8.082h199.82V207.923z"/>
              <path className="c-herounit__logo-path" d="M133.263,205.21c4.775,0,8.402-1.318,10.876-3.944l-2.824-4.901c-1.82,2.299-4.341,3.454-7.563,3.454
                c-2.814,0-5.067-1.074-6.757-3.221c-1.688-2.147-2.532-5.054-2.532-8.706c0-3.659,0.91-6.682,2.73-9.068
                c1.821-2.392,4.155-3.582,7.003-3.582c3.002,0,5.181,0.677,6.535,2.03l2.497-5.018c-2.349-1.605-5.485-2.404-9.406-2.404
                c-4.574,0-8.329,1.698-11.262,5.1c-2.932,3.396-4.399,7.626-4.399,12.686c0,5.427,1.321,9.715,3.968,12.86
                C124.775,203.634,128.486,205.21,133.263,205.21z"/>
              <path className="c-herounit__logo-path" d="M192.336,199.818c-2.319,0-4.677-0.841-7.072-2.521l-2.24,5.438c2.567,1.646,5.447,2.475,8.636,2.475
                c3.673,0,6.603-0.898,8.788-2.685c2.185-1.791,3.279-4.072,3.279-6.839c0-1.54-0.266-2.94-0.794-4.189
                c-0.528-1.254-1.298-2.352-2.311-3.291c-1.013-0.945-2.661-1.972-4.948-3.092c-4.341-2.118-6.512-4.155-6.512-6.115
                c0-1.185,0.385-2.147,1.155-2.883c0.771-0.741,1.855-1.108,3.256-1.108c2.366,0,4.612,0.759,6.745,2.287l1.844-5.229
                c-1.853-1.481-4.752-2.217-8.705-2.217c-3.035,0-5.521,0.869-7.458,2.614c-1.937,1.738-2.905,3.933-2.905,6.582
                c0,1.412,0.245,2.707,0.735,3.874s1.19,2.171,2.101,3.022c0.91,0.846,2.675,1.926,5.298,3.244c2.623,1.313,4.353,2.498,5.193,3.56
                c0.84,1.056,1.261,2.171,1.261,3.338C197.682,198.569,195.898,199.818,192.336,199.818z"/>
            </clipPath>
          </defs>
          <image className="c-herounit__logo-image" href={copper} clipPath="url(#myClip)"/>  
        </svg>
        <div className="c-herounit__title">{props.title}</div>
        <div className="c-herounit__subtitle">{props.tagline}</div>
      </div>
      {props.children}
    </div>
  )
}

export default HeroUnit;



// WEBPACK FOOTER //
// ./src/components/HeroUnit.js